import React, { useEffect, useRef,useState } from 'react';
import pictoClose from "../assets/images/close.svg";
import pictoArchitectureW from "../assets/images/picto-architecture-w.svg";
import pictoArrowLeftW from "../assets/images/arrow-left-w.svg";

export const PopupBatiment = ({closePopupBatiment, showDetailBatiment, batimentCourant, resetAndShowOneLayer}) => {

    return (

        <div id="infos-batiment" className="mini-popup-carte rounded-3 p-4 bg-white shadow position-absolute z-5">
            <div className="d-flex flex-column position-relative">
                <div className="mini-popup-carte-picto rounded-3 ratio-11 d-none d-md-flex align-items-center justify-content-center position-absolute start-0 bg-architecture">
                    <img className="img-fluid w-100 h-100" src={pictoArchitectureW} />
                </div>
                <div className="w-100 d-flex align-items-start justify-content-start pb-3">
                    <div
                        className="dotted-pattern dotted-pattern-architecture dotted-pattern-simple flex-shrink-0"></div>
                    <div className="d-flex flex-column justify-content-center text-start lh-xs px-3">
                        <span className="fw-b fs-5 pb-1" id="titre-batiment">{batimentCourant.nom && batimentCourant.nom}</span>
                        <i className="text-spectral text-architecture">Architecture</i>
                    </div>
                    <button className="toggle-btn ms-auto" id="closePopupBatiment" onClick={closePopupBatiment}>
                        <img src={pictoClose} />
                    </button>
                </div>
                <div className="w-100 d-flex flex-wrap flex-grow-1 align-items-start">
                    <div className="col-12 col-md-4 ratio-11">
                        { batimentCourant.photo &&
                            <img className="w-100 h-100 object-fit-cover rounded-3" id="photo-batiment" src={batimentCourant.photo} />
                        }
                    </div>
                    <div className="col-12 col-md-8 ps-md-3 lh-sm pt-5 pt-md-0">
                        <div className="pb-2">
                            <div className="w-100 d-flex align-items-center">
                                                <span
                                                    className="text-uppercase fw-b fs-8 lh-lg">Matériaux recensés</span>
                                <div
                                    className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>
                            </div>
                            <span className="text-muted text-spectral">
                                {(() => {
                                    if (batimentCourant.infos && batimentCourant.infos.matiere_chaine.length > 0) {
                                        return (
                                            <>
                                                {
                                                    batimentCourant.infos.matiere_chaine.map((matiere_chaine, index) => {
                                                        if(index == 0) return matiere_chaine.groupe_matiere_chaine_id.matiere[0].item.libelle;
                                                        else return ", " + matiere_chaine.groupe_matiere_chaine_id.matiere[0].item.libelle;
                                                    })
                                                }
                                            </>
                                        )
                                    }else{
                                        return "AUCUN";
                                    }
                                })()}
                            </span>
                        </div>
                        <div className="pb-2">
                            <div className="w-100 d-flex align-items-center">
                                                <span className="text-uppercase fw-b fs-8 lh-lg">Plans disponibles</span>
                                <div className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>
                            </div>
                            <span className="text-muted text-spectral">{(() => {
                                if (batimentCourant.infos && batimentCourant.infos.plans.length > 0) {
                                    return (
                                        <>
                                            {
                                                batimentCourant.infos.plans.map((plan, index) => {
                                                    if(index == 0) return plan.item.libelle;
                                                    else return ", " + plan.item.libelle;
                                                })
                                            }
                                        </>
                                    )
                                }else{
                                    return "AUCUN";
                                }
                            })()}</span>
                        </div>
                    </div>
                    <div className="col-12 d-flex mt-auto pt-3">
                        <div className="dotted-pattern opacity-25 dotted-pattern-simple w-100"></div>
                        <a onClick={showDetailBatiment} className="d-flex align-items-center flex-shrink-0 text-architecture text-decoration-none fs-7 ps-3">
                            <span className="pe-3">Voir la fiche</span>
                            <span className="swiper-button-mini bg-architecture rounded-circle flex-shrink-0">
                                <img className="img-fluid w-100 h-100 rotate180" src={pictoArrowLeftW} />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}